import { render, staticRenderFns } from "./RiskFormAnswers.vue?vue&type=template&id=a47926dc"
import script from "./RiskFormAnswers.vue?vue&type=script&lang=js"
export * from "./RiskFormAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports